












































































import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import { DocumentRepoState } from '@/utils/types/store';
import { DocumentRepoCommitDTO } from '@/utils/types/documentRepo/documentRepoCommit';
import * as R from 'ramda';
import { Readability } from '@/utils/types/common';
import format from '@/utils/format';
import functions from '@/utils/functions';

const { ifPresent } = functions;

export default Vue.extend({
  name: 'DocumentRepoInfo',
  data() {
    return {
      documentRepoLoaded: false,
      documentRepoCommitsLoaded: false,
    };
  },
  computed: {
    ...mapState('documentRepo', {
      documentRepo: (state) => (state as DocumentRepoState).documentRepo,
      documentRepoCommits: (state) => (state as DocumentRepoState).documentRepoCommits,
      documentRepoCommit: (state) => (state as DocumentRepoState).documentRepoCommit,
    }),
    latestCommit(): DocumentRepoCommitDTO | undefined {
      return R.last(this.documentRepoCommits);
    },
    deltaRevisionScore(): Readability {
      const thisRevisionHash = this.documentRepoCommit.hash;
      const idx = this.documentRepoCommits.findIndex((v) => v.hash === thisRevisionHash);
      const thisRevisionReadability = Readability.from(this.documentRepoCommits[idx].readability);
      const prevRevisionReadability = idx > 0
        ? Readability.from(this.documentRepoCommits[idx - 1].readability)
        : thisRevisionReadability;
      return thisRevisionReadability.minus(prevRevisionReadability);
    },
  },
  async mounted() {
    const { id } = this.$route.params;
    this.loadDocumentRepo(id).then(() => {
      this.documentRepoLoaded = true;
    });
    this.loadDocumentRepoCommits(id).then(() => {
      this.documentRepoCommitsLoaded = true;
    });
  },
  methods: {
    ...mapActions('documentRepo', [
      'loadDocumentRepo',
      'loadDocumentRepoCommits',
    ]),
    shortenHash: ifPresent(format.shortenHash),
    getTimespan() {
      if (!this.documentRepoCommitsLoaded) return '';
      const { millis: firstMillis } = this.documentRepoCommits[0];
      const { millis: lastMillis } = this.documentRepoCommits[this.documentRepoCommits.length - 1];
      return `${format.formatMonthYear(firstMillis)} – ${format.formatMonthYear(lastMillis)}`;
    },
  },
  filters: {
    getRepositoryNameFromGitURL: format.getRepositoryNameFromGitURL,
    formatDate: ifPresent(format.formatDate),
    formatScore: ifPresent(format.formatReadabilityScore),
    formatDelta: format.formatDelta,
    getColor: (v: number): string => {
      if (v === 0) return 'is-text';
      if (v > 0) return 'is-success';
      return 'is-danger';
    },
  },
});
